module.exports = __webpack_public_path__ + "img/clairvoyance.e61416fe.jpg";